import { render } from "./Timelinecard.vue?vue&type=template&id=a4fcef36&scoped=true"
import script from "./Timelinecard.vue?vue&type=script&lang=js"
export * from "./Timelinecard.vue?vue&type=script&lang=js"

import "./Timelinecard.vue?vue&type=style&index=0&id=a4fcef36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4fcef36"]])

export default __exports__